<template>
  <el-container class="mainContent">
    <!-- 侧边菜单-->
    <el-aside class="menu" :style="{'width':isCollapse?'64px':'200px'}">
      <el-scrollbar>
        <el-menu mode="vertical" :default-active="currRouter.path" :collapse="isCollapse" unique-opened>
          <div class="menu_head">
            <template v-if="!isCollapse">
                             <span v-if="shopInfo" class="menu_head_title" @click="shopClick"
                                   :style="shopInfo.shopName.length>6?'font-size:18px':''">
                               {{ shopInfo.shopName }}
                             </span>
            </template>
            <el-icon v-if="isCollapse" @click="collapseTap" class="menu_head_icon1">
              <Expand/>
            </el-icon>
            <el-icon v-if="!isCollapse" @click="collapseTap" class="menu_head_icon">
              <Fold/>
            </el-icon>
          </div>

          <template v-for="(item,index) in menuList" :key="item.name">
            <!-- 一级菜单-->
            <el-sub-menu :index="item.path"
                         v-if="item.meta.show && ((shopInfo && shopInfo.id > 0) || item.meta.title == '公司管理')">
              <template #title>
                <el-icon>
                  <component :is="item.meta.icon"></component>
                </el-icon>
                <span>{{ item.meta.title }}</span>
              </template>
              <!-- 二级菜单-->
              <template v-for="(item1,index1) in item.children" :key="item1.name">
                <el-menu-item class="menu_item" :class="currRouter.name==item1.name?'menu_item_actor':''"
                              @click="menuClick(item1)"
                              :index="item1.path" v-if="item1.path&&item1.meta.show">
                  <el-icon>
                    <component is="Document"></component>
                  </el-icon>
                  <template #title>{{ item1.meta.title }}</template>
                </el-menu-item>
              </template>
            </el-sub-menu>

          </template>

          <el-sub-menu class="menu_item" @click="jiaoChengClick" index="">
            <template #title>
              <el-icon>
                <svg-icon icon-class="jiaocheng"></svg-icon>
              </el-icon>
              <span>新手教程</span>
            </template>
          </el-sub-menu>
        </el-menu>
      </el-scrollbar>
    </el-aside>
    <!-- 窗口 -->
    <el-container>
      <!-- 头部 -->
      <el-header class="head ">
        <el-scrollbar >
          <div class="head_tab">
            <div class="head_tab_itemHome" @click="tabClick('home')">
              <div class="head_tab_itemHome_text" style="border-right: 1px solid #ff6633"
                   :style="homePage=='房间'?'background: #ff6633;color: #ffffff;':''">
                房间
              </div>
              <div class="head_tab_itemHome_text" :style="homePage=='排场'?'background: #ff6633;color: #ffffff;':''">
                排场
              </div>
            </div>
            <div class="head_tab_item" :class="currRouter.name==item.name?'active':''" ref="item.name"
                 v-for="(item,index) in tabList" :key="item.name" @click="tabClick(item.name)"
                 @contextmenu.prevent="openMenu(item,$event)">
              <div class="head_tab_item_text">{{ item.meta.title }}</div>
              <el-icon class="head_tab_item_icon" :class="currRouter.name==item.name?'active1':''" title="关闭"
                       @click.stop="tabClose(item.name)">
                <Close/>
              </el-icon>
            </div>
          </div>
        </el-scrollbar>
        <ul v-show="visible" class="contextmenu" :style="{left:left+'px',top:top+'px'}">
          <li class="contextmenuLi" @click.stop="contextmenu(0)">关闭其他</li>
          <li class="contextmenuLi" @click.stop="contextmenu(1)">全部关闭</li>
        </ul>
        <div class="head_info">
          <div class="head_tips" v-if="!shopInfo.vipTime">当前免费版，数据仅保留近60天，请及时下载留存!</div>
          <div class="head_info_item" @mouseenter="isHovered = true" @mouseleave="isHovered = false">
            <img class="head_info_item_vip"
                 :src="shopInfo.vipTime?require('@/assets/vip1.png'):require('@/assets/vip.png')">
            <div class="content_vip" v-if="isHovered">
              <template v-if="shopInfo.vipTime">
                <div class="content_vip_row">
                  <div class="content_vip_kaitong">
                    VIP用户
                  </div>
                  <div class="content_vip_text">
                    {{ shopInfo.vipTime }}到期
                  </div>
                </div>
                <div class="content_vip_btn" @click="topUpClick">
                  立即续费
                </div>
              </template>
              <template v-else>
                <div class="content_vip_row">
                  <div class="content_vip_kaitong">
                    开通VIP
                  </div>
                  <div class="content_vip_text">
                    畅享专属权益
                  </div>

                </div>
                <div class="content_vip_btn" @click="topUpClick">
                  立即开通
                </div>
              </template>
              <div class="content_vip_text">
                <a style="font-size: 12px" target="_blank" href="https://m.jxkj1987.com/nd.jsp?id=1339">查看详情</a>
              </div>

            </div>
          </div>
          <el-dropdown>
            <div class="head_info_item">

              <img class="head_info_item_img"
                   :src="userInfo.headerUrl?userInfo.headerUrl:'https://demo.buildadmin.com/static/images/avatar.png'">
              <div class="head_info_item_text">{{ userInfo.note ? userInfo.note : userInfo.nickName }}</div>
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item>
                  <span @click="userClick">个人信息</span>
                </el-dropdown-item>
                <el-dropdown-item>
                  <span @click="loginOut">退出登录</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>

        </div>
      </el-header>
      <!-- 主体 -->
      <el-scrollbar>
        <el-main class="body">
          <router-view v-slot="{ Component }">
            <transition name="slide-right" mode="out-in">
              <keep-alive :include="getKeepAliveList">
                <component :is="Component" :key="$route.fullPath"/>
              </keep-alive>
            </transition>
          </router-view>
        </el-main>
      </el-scrollbar>
    </el-container>

    <!-- 选择门店 -->
    <dialogBox ref="dialogBox" :center="true"></dialogBox>

    <!-- 开通会员窗口 -->
    <openVip ref="openVip"></openVip>
    <div v-if="showPopup" class="popup-overlay">
      <div class="popup-content">
        <!-- 关闭按钮 -->
        <button class="popup-close" @click="closePopup">×</button>
        <!-- 点击图片跳转 -->
        <a :href="updateLink" target="_blank" rel="noopener noreferrer">
          <img :src="updateImg" alt="更新提示" class="popup-img"/>
        </a>
      </div>
    </div>
  </el-container>
</template>

<script>
import dialogBox from '@/components/dialogBox.vue'
import openVip from '@/components/openVip.vue'
import {ver} from "@/utils/api";

export default {
  name: "index",
  components: {
    dialogBox,
    openVip,
  },
  data() {
    return {
      showPopup: false, // 控制是否显示
      updateImg: "https://script-res-cdn.jxkj1987.cn/eoms_image/version_update.png", // 图片地址
      updateLink: "https://m.jxkj1987.com/nd.jsp?id=1371", // 外部链接
      documentObj: null,     //head左右滑动用到的元素对象
      visible: false,         //head右键菜单显示开关
      top: 0,
      left: 0,
      currItem: null,          //当前打开右键菜单的tab
      isCollapse: false,       //是否折叠：false 展开，true 折叠
      // homePage:'房间',        //首页名称
      //选择对话框
      dialogBoxData: {
        state: true,
        title: '',
        prop: 'shopName',
        select: 0,
        data: {},
        click: (item, index) => {
          this.$tools.switchShopCore(item.id);
          location.reload();
        },
        close: res => {
        }
      },
      isHovered: false,

    }
  },
  computed: {
    menuList() {
      return this.$store.state.menuList;
    },
    // 获取缓存列表
    getKeepAliveList() {
      return this.$store.getters.getKeepAliveList
    },
    tabList() {
      return this.$store.state.tabList;
    },
    currRouter() {
      return this.$store.state.currRouter;
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
    companyInfo() {
      return this.$store.state.companyInfo;
    },
    shopInfo() {
      return this.$store.state.shopInfo;
    },
    homePage() {
      return this.$store.state.homePage;
    },
  },
  watch: {
    visible(value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    }
  },
  methods: {
    handleUpdateSystem() {
      this.$POST("/customer/eomsVersion/version", {platform: "WEB", version: ver()}).then(res => {

        this.showPopup = !!!res.data.isRead
      })
    },
    //关闭更新广告
    closePopup() {
      this.$POST("/customer/eomsVersion/version/read", {platform: "WEB", version: ver(), isRead: 1}).then(res => {
        this.showPopup = false;
      })
    },
    /**
     * 开通vip点击
     */
    topUpClick() {
      this.$refs.openVip.initData({
        onClose: () => {
          this.$tools.switchShopCore(this.$store.state.shopInfo.id)
        }
      })
      window.$openVip = this.$refs.openVip
    },

    /**
     * 教程点击点击
     */
    jiaoChengClick() {
      window.open("https://www.jxkj1987.com/h-nd-1302.html")
    },

    /**
     * 个人信息点击
     */
    userClick() {
      this.$router.push({
        name: "userInfo"
      });
    },

    /**
     * 门店点击
     */
    shopClick() {
      this.dialogBoxData.state = true;
      this.dialogBoxData.title = this.companyInfo.companyName;
      this.dialogBoxData.data = this.companyInfo.shopList;
      this.dialogBoxData.select = this.shopInfo.currShop;
      this.$refs.dialogBox.initData(this.dialogBoxData);
      if (process.env.NODE_ENV === "development") {
      } else {
      }
    },

    /**
     * 折叠点击
     */
    collapseTap() {
      this.isCollapse = !this.isCollapse;
      localStorage.setItem("isCollapse", JSON.stringify(this.isCollapse));
    },

    /**
     * 左侧菜单点击
     */
    menuClick(e) {
      if (e.name === "dashboard") {
        const shopId = this.$store.state.shopInfo.id;

        // Vue CLI 本地 npm run serve 时一般是 development
        const prefix =
            process.env.NODE_ENV === "development" ? "" : "/businessadmin";

        const url = `${window.location.origin}${prefix}/dashboardData/index.html?shopId=${encodeURIComponent(shopId)}`;

        window.open(url, "_blank");
        return;
      }

      this.$router.push({ name: e.name });
    },

    /**
     * 退出登陆点击
     */
    loginOut: function () {
      this.$router.push({
        name: 'login'
      });
    },

    /**
     * tab点击
     */
    tabClick: function (name) {
      //如果当前路由是home,切换home页面
      if (name == 'home') {
        let homePage = this.$store.state.homePage;
        //已激活则切换
        if (this.$store.state.currRouter.path == "/index/home") {
          homePage = homePage == '房间' ? '排场' : '房间';
        }
        localStorage.setItem("homepage", homePage);
        this.$store.commit("setHomepage", homePage)
      }
      this.$router.push({
        name: name
      });
    },

    /**
     * tab关闭点击
     */
    tabClose: function (name) {
      let tabList = this.$store.state.tabList;
      let currRouter = this.$store.state.currRouter;
      //判断关闭后显示页面
      for (let i = 0; i < tabList.length; i++) {
        if (tabList[i].name == name) {
          tabList.splice(i, 1);
          i--;
          if (name == currRouter.name) {
            if (tabList.length > 0 && tabList[i] && tabList[i].name) {
              this.$router.push({
                name: tabList[i].name
              });
            } else {
              this.$router.push({
                name: 'home'
              });
            }
          }
        }

      }
    },

    /**
     * 打开tab菜单
     * @param tab
     * @param e
     */
    openMenu: function (tab, e) {
      this.top = e.clientY - 10;
      this.left = e.clientX - 230;
      this.visible = true;
      this.currItem = tab;
    },

    /**
     * 关闭tab菜单
     */
    closeMenu: function () {
      this.visible = false
    },

    /**
     * tab菜单点击
     * @param e
     */
    contextmenu: function (e) {
      let tabList = this.$store.state.tabList;
      //关闭其他
      if (e === 0) {
        for (let i = 0; i < tabList.length; i++) {
          if (tabList[i].name != this.currItem.name) {
            tabList.splice(i, 1);
            i--;
          }
        }
      }
      //关闭全部
      if (e === 1) {
        for (let i = 0; i < tabList.length; i++) {
          tabList.splice(i, 1);
          i--;
        }
        this.$router.push({name: 'home'});
      }
      this.visible = false;
    },


  },
  mounted() {
    this.$nextTick(()=>{
      const cacheIsCollapse = localStorage.getItem("isCollapse");
      // 本地没有记录时默认展开；有记录时按本设备缓存恢复，跟登录用户无关
      this.isCollapse = cacheIsCollapse === null ? false : JSON.parse(cacheIsCollapse);
    })
    // this.isCollapse = true;    //默认是关闭的
    // this.$store.commit("setHomepage", localStorage.getItem("homepage")?localStorage.getItem("homepage"):'房间')
    this.$store.commit("setHomepage", '房间');    //默认是房间

    //查询系统是否更新
    this.handleUpdateSystem()
    //暴露全局 组件
    window.$openVip = this.$refs.openVip
  }
};
</script>

<style scoped>
.content_vip {
  position: fixed;
  top: 65px;
  right: 15px;
  height: 90px;
  width: 250px;
  border-radius: 8px;
  background-size: cover;
  z-index: 999;
  background: url(https://script-res-cdn.jxkj1987.cn/eoms_image/vip_qr/orange.png) no-repeat center center;
}

.content_vip_row {
  position: relative;
  height: 50px;
  width: 80%;
  margin-top: 12px;
}

.content_vip_kaitong {
  position: relative;
  font-size: 20px;
  font-weight: 800;
  color: #4e0a0a;
  margin-left: 20px;
}

.content_vip_text {
  position: relative;
  font-size: 15px;
  font-weight: 400;
  color: #332b04;
  margin-left: 20px;
}

.content_vip_btn {
  position: absolute;
  right: 10px;
  top: 22px;
  background: linear-gradient(to right, #fa5213, #ff8045);
  border-radius: 20px;
  color: #ffffff;
  font-size: 14px;
  height: 35px;
  width: 90px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.content_vip_btn:hover {
  opacity: 0.8;
}


.mainContent {
  position: relative;
  width: 100vw;
  height: 100vh;
  color: #333333;
  background: #f2f2f2;
  min-width: 1366px;
  min-height: 768px;
}

:deep(.el-menu) {
  border-right: none;
}

:deep(.el-menu-item.is-active) {
  color: #ff6633;
}

:deep(.el-dialog__body) {
  margin-top: 10px;
}

:deep(.el-menu--collapse .el-sub-menu.is-active .el-sub-menu__title) {
  color: #ff6633;
}

.menu {
  position: relative;
  margin: 14px 0 14px 14px;
  height: calc(100vh - 28px);
  overflow: hidden;
  transition: width 0.3s ease;
  box-shadow: 1px 2px 9px 1px rgba(73, 73, 73, 0.1);
  border-radius: 8px;
  background: #ffffff;
}

.menu_head {
  position: sticky;
  top: 0;
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ff6633;
  font-weight: 800;
  font-size: 24px;
  overflow: hidden;
  text-overflow: clip;
  white-space: nowrap;
  z-index: 9;
  background: #ffffff;
  cursor: pointer;
}

.menu_head_title {
  position: relative;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: clip;
  margin-right: 10px;
}

.menu_head_icon {
  position: relative;
  margin-top: 4px;
  cursor: pointer;
}

.menu_head_icon1 {
  position: relative;
  cursor: pointer;
}

:deep(.el-sub-menu__title:hover) {
  background-color: #ffece6;
  color: #ff6633;
}

.menu_item {
  height: 50px;
  font-size: 15px;
}

.menu_item_actor {
  background-color: #ffece6;
  color: #ff6633;
  border-left: 5px solid #ff6633;
}

.menu_item:hover {
  background-color: #ffece6;
  color: #ff6633;
}

.menu_item:focus {
  background-color: #ffe5d5;
  color: #ff6633;
  border-left: 5px solid #ff6633;
}

.head {
  position: relative;
  height: 60px;
  margin: 14px 14px 12px;
  box-shadow: 1px 2px 9px 1px rgba(73, 73, 73, 0.1);
  border-radius: 8px;
  background: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.head_tab {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 60px;
}

:deep(.el-header) {
  --el-header-padding: 0 10px;
}

.head_tab_itemHome {
  position: relative;
  height: 32px;
  width: 100px;
  border: 1px solid #ff6633;
  color: #ff6633;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 8px;
  white-space: nowrap;
  cursor: pointer;
}

.head_tab_itemHome_text {
  position: relative;
  height: 100%;
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.head_tab_item {
  position: relative;
  height: 32px;
  border: 1px solid #ff6633;
  color: #ff6633;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 8px;
  white-space: nowrap;
}

.active {
  background: #ff6633;
  color: #ffffff;
}

.head_tab_item:hover {
  cursor: pointer;
}

.head_tab_item_text {
  position: relative;
  font-size: 12px;
  padding-left: 12px;
  padding-right: 12px;
}

.head_tab_item_text_img {
  position: relative;
  height: 18px;
  width: 18px;
  margin-left: 4px;
}

.head_tab_item_icon {
  position: relative;
  color: #ff233e !important;
  margin-right: 5px;
  margin-left: -10px;
  font-size: 15px;
  z-index: 9;
  border-radius: 2px;
}

.head_tab_item_icon:hover {
  background: rgba(255, 14, 12, 0.8);
  border-radius: 50%;
  color: #f2f2f2 !important;
}

.active1 {
  color: #f2f2f2 !important;
}

.contextmenu {
  margin: 0;
  background: #fff;
  z-index: 3000;
  position: absolute;
  list-style-type: none;
  padding: 5px 0;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #333;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, .3);
}

.contextmenuLi {
  margin: 0;
  padding: 7px 16px;
  cursor: pointer;
}

.contextmenuLi:hover {
  background: #eee;
}

.head_info {
  position: relative;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  overflow: hidden;
  cursor: pointer;
  margin-right: 10px;
}

.head_tips {
  display: inline-flex;
  align-items: center;
  height: 36px;
  padding: 0 16px;

  font-size: 14px;
  font-weight: 500;
  color: #ff5a3c;

  background: linear-gradient(
      90deg,
      rgba(255, 90, 60, 0.08),
      rgba(255, 140, 0, 0.12)
  );
  border: 1px solid rgba(255, 90, 60, 0.25);
  border-radius: 10px;
  box-shadow:
      0 2px 8px rgba(255, 90, 60, 0.08),
      inset 0 1px 0 rgba(255,255,255,0.5);
  letter-spacing: 0.3px;
  transition: all 0.25s ease;
  margin-right: 10px;
}

.head_tips:hover {
  transform: translateY(-1px);
  box-shadow:
      0 6px 16px rgba(255, 90, 60, 0.15);
}

.head_info_item {
  position: relative;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  outline: none !important;  /* 标准写法，所有浏览器 */
}

.head_info_item_img {
  position: relative;
  width: 30px;
  height: 30px;
  border-radius: 50%;
}

.head_info_item_text {
  position: relative;
  font-size: 14px;
  margin-left: 10px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 80px;
}

.head_info_item_vip {
  position: relative;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  margin-right: 12px;
  cursor: pointer;
  user-select: none;
  pointer-events: none;
}

.body {
  position: relative;
  margin-bottom: 14px;
  margin-right: 14px;
  margin-left: 14px;
  box-shadow: 1px 2px 9px 1px rgba(73, 73, 73, 0.1);
  border-radius: 8px;
  background: #ffffff;
  padding: 14px 14px 8px;
}

.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.popup-content {
  position: relative;
  max-width: 90%;
  max-height: 80%;
}

.popup-img {
  display: block;
  max-width: 100%;
  max-height: 100%;
  border-radius: 8px;
  cursor: pointer;
}

.popup-close {
  position: absolute;
  top: -12px;
  right: -12px;
  background: #fff;
  border: none;
  border-radius: 50%;
  font-size: 20px;
  cursor: pointer;
  width: 28px;
  height: 28px;
  line-height: 26px;
  text-align: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}

</style>
